export default "__VITE_ASSET__Cwo8GgZ___"